import instance from "../api/instance";
import { logout } from "./sessionActions";

import {
  SET_CURRENCY,
  SET_CURRENCIES,
  GET_EMPTY_BILLS,
  GET_CREDIT_LINE,
  CLEAR_EMPTY_BILLS,
  GET_CREDIT_LINE_BY_CIF,
  GET_TRANSACTIONS_BY_STATUS,
  GET_DISTRIBUTION_GRAPH,
  GET_EXPIRATION_DATES,
} from "../constants/constants";

export const getCustomerCreditLine = (allCompanies = false) => {
  let url = allCompanies === true ? `/credit-lines/all` : `/credit-lines/me`;
  return (dispatch) => {
    return instance
      .get(`${url}`)
      .then((response) => {
        dispatch({ type: GET_CREDIT_LINE, creditLine: response.data.data });
        if (response.data.data.length > 0 && !allCompanies) {
          dispatch({
            type: SET_CURRENCY,
            currency: response.data.data[0].currencyCode,
          });
        }

        // Set Available Currencies
        var currencies = [];
        response.data.data.map((line) => currencies.push(line.currencyDetail));
        dispatch({ type: SET_CURRENCIES, currencies });

        return response.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getTransactionsByStatus = () => {
  return (dispatch) => {
    return instance
      .get(`/dashboard/transactions_by_status`)
      .then((response) => {
        var data = response.data.data;

        if (data.list.length > 0) {
          dispatch({
            type: GET_TRANSACTIONS_BY_STATUS,
            transactions: data,
          });
          dispatch({
            type: GET_EMPTY_BILLS,
            emptyBills: false,
          });
        } else {
          dispatch({
            type: GET_EMPTY_BILLS,
            emptyBills: true,
          });
        }
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const getDistributionGraph = () => {
  return (dispatch) => {
    return instance
      .get(`/dashboard/distribution_by_utilization`)
      .then((response) => {
        dispatch({
          type: GET_DISTRIBUTION_GRAPH,
          distribution: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const getExpirationDates = () => {
  return (dispatch) => {
    return instance
      .get(`/dashboard/expirations`)
      .then((response) => {
        dispatch({
          type: GET_EXPIRATION_DATES,
          calendar: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const getCreditLineByCif = (cif, countryCode) => {
  return (dispatch) => {
    return instance
      .get(`/credit-lines/${cif}/${countryCode}`)
      .then((response) => {
        dispatch({
          type: GET_CREDIT_LINE_BY_CIF,
          creditLine: response.data.data,
        });
        return response.data.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const setCurrency = (currency) => {
  return (dispatch) => {
    dispatch({ type: SET_CURRENCY, currency });
  };
};

export const clearEmptyBills = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_EMPTY_BILLS });
  };
};
